import { render, staticRenderFns } from "./voiceItem.vue?vue&type=template&id=42ec1142&scoped=true"
import script from "./voiceItem.vue?vue&type=script&lang=js"
export * from "./voiceItem.vue?vue&type=script&lang=js"
import style0 from "./voiceItem.vue?vue&type=style&index=0&id=42ec1142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec1142",
  null
  
)

export default component.exports